var $54b47fc030b7b21e$exports = {};
const $54b47fc030b7b21e$var$track = document.querySelector(".all-video-track");
const $54b47fc030b7b21e$var$viewport = document.querySelector(".all-video-viewport");
const $54b47fc030b7b21e$var$soundButtons = document.querySelectorAll(".all-video .sound");
const $54b47fc030b7b21e$var$infoButtons = document.querySelectorAll(".all-video .info");
const $54b47fc030b7b21e$var$exitButtons = document.querySelectorAll(".all-video .exit");
const $54b47fc030b7b21e$var$folderButtons = document.querySelectorAll(".all-video .folder");
const $54b47fc030b7b21e$var$movingImages = document.querySelectorAll(".img-moving img");
const $54b47fc030b7b21e$var$popupContents = document.querySelectorAll(".popUp .popup-content");
const $54b47fc030b7b21e$var$levelNavButtons = document.querySelectorAll(".level-nav h2");
const $54b47fc030b7b21e$var$folderOpenSvg = {
    width: "95",
    height: "87",
    viewBox: "0 0 95 87",
    paths: `
    <path d="M4.31824 60.4554H0V4.31824H4.31824V0H34.546V4.31824H38.8642V8.63649H77.7284V12.9547H82.0466V30.2277H17.273V34.5459H12.9547V43.1824H8.63649V51.8189H4.31824V60.4554Z" fill="white"/>
    <path d="M94.9995 34.5459V43.1824H90.6813V51.8189H86.363V60.4554H82.0448V69.0918H77.7265V82.0466H73.4083V86.3648H8.63465V82.0466H4.31641V69.0918H8.63465V60.4554H12.9529V51.8189H17.2711V43.1824H21.5894V34.5459H94.9995Z" fill="white"/>
  `
};
const $54b47fc030b7b21e$var$soundOnSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="73" height="73" viewBox="0 0 73 73" fill="none">
  <path d="M19.9091 73H53.0909V66.3636H66.3636V53.0909H73V19.9091H66.3636V6.63636H53.0909V0H19.9091V6.63636H6.63636V19.9091H0V53.0909H6.63636V66.3636H19.9091V73Z" fill="white"/>
  <path d="M41.8571 16V58H35.4286V55.9H33.2857V53.8H31.1429V51.7H29V49.6H26.8571V47.5H24.7143V45.4H14V28.6H24.7143V26.5H26.8571V24.4H29V22.3H31.1429V20.2H33.2857V18.1H35.4286V16H41.8571Z" fill="black"/>
</svg>`;
const $54b47fc030b7b21e$var$soundOffSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="73" height="73" viewBox="0 0 73 73" fill="none">
  <path d="M19.9091 73H53.0909V66.3636H66.3636V53.0909H73V19.9091H66.3636V6.63636H53.0909V0H19.9091V6.63636H6.63636V19.9091H0V53.0909H6.63636V66.3636H19.9091V73Z" fill="white"/>
  <path d="M41.8571 16V58H35.4286V55.9H33.2857V53.8H31.1429V51.7H29V49.6H26.8571V47.5H24.7143V45.4H14V28.6H24.7143V26.5H26.8571V24.4H29V22.3H31.1429V20.2H33.2857V18.1H35.4286V16H41.8571ZM59 28.6V32.8H56.8571V34.9H54.7143V39.1H56.8571V41.2H59V45.4H54.7143V43.3H52.5714V41.2H50.4286V43.3H48.2857V45.4H44V41.2H46.1429V39.1H48.2857V34.9H46.1429V32.8H44V28.6H48.2857V30.7H50.4286V32.8H52.5714V30.7H54.7143V28.6H59Z" fill="black"/>
</svg>`;
let $54b47fc030b7b21e$var$slides = [];
let $54b47fc030b7b21e$var$currentIndex = 1;
let $54b47fc030b7b21e$var$slideWidth = 0;
let $54b47fc030b7b21e$var$isMoving = false;
const $54b47fc030b7b21e$var$updateActiveVideo = ()=>{
    if (!$54b47fc030b7b21e$var$slides.length) return;
    const activeSlide = $54b47fc030b7b21e$var$slides[$54b47fc030b7b21e$var$currentIndex];
    const videos = $54b47fc030b7b21e$var$track.querySelectorAll("video");
    videos.forEach((video)=>{
        if (activeSlide && activeSlide.contains(video)) {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") playPromise.catch(()=>{});
        } else video.pause();
    });
};
const $54b47fc030b7b21e$var$updateSlideWidth = ()=>{
    if (!$54b47fc030b7b21e$var$viewport || !$54b47fc030b7b21e$var$track) return;
    $54b47fc030b7b21e$var$slideWidth = $54b47fc030b7b21e$var$viewport.getBoundingClientRect().width;
    $54b47fc030b7b21e$var$track.style.transform = `translateX(${-$54b47fc030b7b21e$var$currentIndex * $54b47fc030b7b21e$var$slideWidth}px)`;
};
const $54b47fc030b7b21e$var$jumpToIndex = (index)=>{
    $54b47fc030b7b21e$var$track.style.transition = "none";
    $54b47fc030b7b21e$var$currentIndex = index;
    $54b47fc030b7b21e$var$track.style.transform = `translateX(${-$54b47fc030b7b21e$var$currentIndex * $54b47fc030b7b21e$var$slideWidth}px)`;
    window.requestAnimationFrame(()=>{
        $54b47fc030b7b21e$var$track.style.transition = "transform 500ms ease";
    });
    $54b47fc030b7b21e$var$updateActiveVideo();
    $54b47fc030b7b21e$var$updateActiveNavButton();
};
const $54b47fc030b7b21e$var$updateActiveNavButton = ()=>{
    $54b47fc030b7b21e$var$levelNavButtons.forEach((button, index)=>{
        if (index === $54b47fc030b7b21e$var$currentIndex - 1) button.classList.add("active");
        else button.classList.remove("active");
    });
};
const $54b47fc030b7b21e$var$goToLevel = (level)=>{
    if (!$54b47fc030b7b21e$var$track || !$54b47fc030b7b21e$var$slides.length || $54b47fc030b7b21e$var$isMoving) return;
    $54b47fc030b7b21e$var$isMoving = true;
    $54b47fc030b7b21e$var$currentIndex = level + 1; // +1 because of the cloned first slide
    $54b47fc030b7b21e$var$track.style.transform = `translateX(${-$54b47fc030b7b21e$var$currentIndex * $54b47fc030b7b21e$var$slideWidth}px)`;
    $54b47fc030b7b21e$var$updateActiveVideo();
    $54b47fc030b7b21e$var$updateActiveNavButton();
};
if ($54b47fc030b7b21e$var$track && $54b47fc030b7b21e$var$viewport) {
    const originals = Array.from($54b47fc030b7b21e$var$track.children);
    if (originals.length > 1) {
        const firstClone = originals[0].cloneNode(true);
        const lastClone = originals[originals.length - 1].cloneNode(true);
        $54b47fc030b7b21e$var$track.appendChild(firstClone);
        $54b47fc030b7b21e$var$track.insertBefore(lastClone, originals[0]);
    }
    $54b47fc030b7b21e$var$slides = Array.from($54b47fc030b7b21e$var$track.children);
    $54b47fc030b7b21e$var$track.style.transition = "transform 500ms ease";
    $54b47fc030b7b21e$var$updateSlideWidth();
    $54b47fc030b7b21e$var$updateActiveVideo();
    $54b47fc030b7b21e$var$updateActiveNavButton();
    window.addEventListener("resize", $54b47fc030b7b21e$var$updateSlideWidth);
    $54b47fc030b7b21e$var$track.addEventListener("transitionend", ()=>{
        if (!$54b47fc030b7b21e$var$slides.length) return;
        if ($54b47fc030b7b21e$var$currentIndex === $54b47fc030b7b21e$var$slides.length - 1) $54b47fc030b7b21e$var$jumpToIndex(1);
        if ($54b47fc030b7b21e$var$currentIndex === 0) $54b47fc030b7b21e$var$jumpToIndex($54b47fc030b7b21e$var$slides.length - 2);
        $54b47fc030b7b21e$var$isMoving = false;
        $54b47fc030b7b21e$var$updateActiveVideo();
    });
}
// Level navigation event listeners
$54b47fc030b7b21e$var$levelNavButtons.forEach((button)=>{
    button.addEventListener("click", ()=>{
        const level = parseInt(button.dataset.level);
        $54b47fc030b7b21e$var$goToLevel(level);
    });
});
$54b47fc030b7b21e$var$soundButtons.forEach((button)=>{
    button.addEventListener("click", (event)=>{
        event.stopPropagation();
        const game = button.closest(".game");
        if (!game) return;
        const video = game.querySelector("video:not(.glitch)");
        if (!video) return;
        video.muted = !video.muted;
        button.setAttribute("aria-label", video.muted ? "Activer le son" : "Couper le son");
        button.innerHTML = video.muted ? $54b47fc030b7b21e$var$soundOffSvg : $54b47fc030b7b21e$var$soundOnSvg;
    });
});
$54b47fc030b7b21e$var$infoButtons.forEach((button)=>{
    button.addEventListener("click", (event)=>{
        event.stopPropagation();
        const game = button.closest(".game");
        if (!game) return;
        const popup = game.querySelector(".popUp");
        if (!popup) return;
        // Toggle : ouvre si fermé, ferme si ouvert
        popup.classList.toggle("is-open");
    });
});
$54b47fc030b7b21e$var$exitButtons.forEach((button)=>{
    button.addEventListener("click", (event)=>{
        event.stopPropagation();
        const hidding = button.closest(".hidding");
        if (hidding) {
            hidding.classList.remove("is-visible");
            return;
        }
        const popup = button.closest(".popUp");
        if (!popup) return;
        popup.classList.remove("is-open");
    });
});
$54b47fc030b7b21e$var$folderButtons.forEach((folder)=>{
    if (!folder.dataset.svgStored) {
        folder.dataset.svgStored = "true";
        folder.dataset.originalPaths = folder.innerHTML;
        folder.dataset.originalWidth = folder.getAttribute("width") || "";
        folder.dataset.originalHeight = folder.getAttribute("height") || "";
        folder.dataset.originalViewBox = folder.getAttribute("viewBox") || "";
        folder.dataset.state = "closed";
    }
    folder.addEventListener("click", (event)=>{
        event.stopPropagation();
        const game = folder.closest(".game");
        if (!game) return;
        const moving = game.querySelector(".img-moving");
        if (!moving) return;
        moving.classList.toggle("is-open");
        if (folder.dataset.state === "closed") {
            folder.setAttribute("width", $54b47fc030b7b21e$var$folderOpenSvg.width);
            folder.setAttribute("height", $54b47fc030b7b21e$var$folderOpenSvg.height);
            folder.setAttribute("viewBox", $54b47fc030b7b21e$var$folderOpenSvg.viewBox);
            folder.innerHTML = $54b47fc030b7b21e$var$folderOpenSvg.paths;
            folder.dataset.state = "open";
        } else {
            folder.setAttribute("width", folder.dataset.originalWidth);
            folder.setAttribute("height", folder.dataset.originalHeight);
            folder.setAttribute("viewBox", folder.dataset.originalViewBox);
            folder.innerHTML = folder.dataset.originalPaths;
            folder.dataset.state = "closed";
        }
    });
});
const $54b47fc030b7b21e$var$hiddingBlocks = document.querySelectorAll(".hidding");
const $54b47fc030b7b21e$var$draggableImages = [
    ...$54b47fc030b7b21e$var$movingImages,
    ...$54b47fc030b7b21e$var$popupContents,
    ...$54b47fc030b7b21e$var$hiddingBlocks
];
const $54b47fc030b7b21e$var$startDrag = (target, event)=>{
    event.preventDefault();
    const game = target.closest(".game");
    if (!game) return;
    const video = game.querySelector("video:not(.glitch)");
    const gameRect = game.getBoundingClientRect();
    const videoRect = video ? video.getBoundingClientRect() : gameRect;
    const targetRect = target.getBoundingClientRect();
    const offsetX = event.clientX - targetRect.left;
    const offsetY = event.clientY - targetRect.top;
    const minLeft = videoRect.left - gameRect.left;
    const minTop = videoRect.top - gameRect.top;
    const maxLeft = videoRect.right - gameRect.left - targetRect.width;
    const maxTop = videoRect.bottom - gameRect.top - targetRect.height;
    const move = (moveEvent)=>{
        const x = moveEvent.clientX - gameRect.left - offsetX;
        const y = moveEvent.clientY - gameRect.top - offsetY;
        const clampedX = Math.min(Math.max(x, minLeft), maxLeft);
        const clampedY = Math.min(Math.max(y, minTop), maxTop);
        target.style.left = `${clampedX}px`;
        target.style.top = `${clampedY}px`;
    };
    const up = ()=>{
        window.removeEventListener("pointermove", move);
        window.removeEventListener("pointerup", up);
        target.style.cursor = "grab";
    };
    target.style.cursor = "grabbing";
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
};
$54b47fc030b7b21e$var$draggableImages.forEach((img)=>{
    img.addEventListener("pointerdown", (event)=>{
        if (event.target.closest(".exit")) return;
        $54b47fc030b7b21e$var$startDrag(img, event);
    });
});
const $54b47fc030b7b21e$var$glitchVideos = document.querySelectorAll(".glitch");
$54b47fc030b7b21e$var$glitchVideos.forEach((video)=>{
    video.addEventListener("pointerdown", (event)=>{
        const popup = video.closest(".popup-content");
        if (!popup) return;
        event.stopPropagation();
        $54b47fc030b7b21e$var$startDrag(popup, event);
    });
    video.addEventListener("click", ()=>{
        const popup = video.closest(".popup-content");
        if (!popup) return;
        const hidding = popup.nextElementSibling;
        if (hidding && hidding.classList.contains("hidding")) hidding.classList.add("is-visible");
    });
});
const $54b47fc030b7b21e$var$buttonForm = document.querySelector(".button-form");
if ($54b47fc030b7b21e$var$buttonForm) {
    const toggleCasseTete = (game)=>{
        const wrapper = game.querySelector(".casse-tete-wrapper");
        const casseTeteVideo = wrapper ? wrapper.querySelector(".casse-tete") : null;
        if (!wrapper) return;
        const isOpen = wrapper.classList.toggle("is-open");
        if (isOpen && casseTeteVideo) {
            casseTeteVideo.currentTime = 0;
            casseTeteVideo.muted = false;
            casseTeteVideo.play().catch(()=>{});
            const soundButton = game.querySelector(".sound");
            if (soundButton) {
                soundButton.innerHTML = $54b47fc030b7b21e$var$soundOnSvg;
                soundButton.setAttribute("aria-label", "Couper le son");
            }
        } else if (casseTeteVideo) {
            casseTeteVideo.pause();
            casseTeteVideo.muted = true;
        }
    };
    $54b47fc030b7b21e$var$buttonForm.addEventListener("click", (event)=>{
        event.stopPropagation();
        const game = $54b47fc030b7b21e$var$buttonForm.closest(".game");
        if (!game) return;
        toggleCasseTete(game);
    });
    const wrapper = $54b47fc030b7b21e$var$buttonForm.closest(".game")?.querySelector(".casse-tete-wrapper");
    if (wrapper) wrapper.addEventListener("click", (event)=>{
        event.stopPropagation();
        const game = wrapper.closest(".game");
        if (!game) return;
        toggleCasseTete(game);
    });
}


//# sourceMappingURL=index.7fd145c3.js.map
